import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentFY } from "../../Utilitie";
import Loading from "../../Extra/Loading";
import MonthWiseOutsideRest from "./MonthWiseOutsideRest";
import LobbyWiseOutsideRest from "./LobbyWiseOutsideRest";
import CrewOutsideFilter from "./CrewOutsideFilter";
import NoDataFound from "../../Extra/NoDataFound";
import StationWiseOutSideRest from "./StationWiseOutSideRest";
import CrewOutsideGraph from "./CrewOutsideGraph";

const opState = {
  Year: false,
  Months: false,
  Lobby: false,
  Station: false,
};
const CrewOutsideMaster = () => {
  const [treeMapPath, setTreeMapPath] = useState({});
  const [selectedLineBar, setSelectedLineBar] = useState("");
  const [selectedBar, setSelectedBar] = useState([]);

  const addSelectedBar = (newObj) => {
    setSelectedBar((prev) => {
      // find dynamic key (lobby / month / station / etc.)
      const identityKey = Object.keys(newObj).find(
        (key) => key !== "barValue" && key !== "seriesName",
      );

      if (!identityKey) return prev;

      // remove all previous objects that contain the same key name
      const filtered = prev.filter((item) => !(identityKey in item));

      // add the new object
      return [...filtered, newObj];
    });
  };
  useEffect(() => {
    addSelectedBar(selectedLineBar);
  }, [selectedLineBar]);

  const urlPrefixBlock = process.env.REACT_APP_URL_CMS_PREFIX;
  const [hqData, setHqData] = useState(null);
  const currentYear = getCurrentFY();
  const [year, setYear] = useState(currentYear.slice(0, 4));
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i,
  ); // last 10 years
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}cms_hq_crew_rest_at_outstation?os_year=${year}`,
      );
      setLoading(false);
      // console.log(response.status, response.statusText);
      // console.log("FULL RESPONSE DATA:", response.data);

      if (response.statusText === "OK") {
        setHqData([
          ...(response.data.current_data || []),
          ...(response.data.previous_data || []),
        ]);
      }
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [year]);

  return (
    <div onClick={() => setOpenStates(opState)}>
      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <div>
          <h5 className="">HQ Crew Rest At Outstation{}</h5>
        </div>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(2, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {loading && <Loading />}
      <>
        {loading && <Loading />}

        {hqData && (
          <div className="sticky-controller">
            <CrewOutsideFilter
              data={hqData}
              setSelectedFilters={setSelectedFilters}
              setFilteredData={setFilteredData}
              openStates={openStates}
              setOpenStates={setOpenStates}
            />
          </div>
        )}
        {filteredData?.length > 0 || <NoDataFound />}
        {/* {filteredData?.length > 0 && (
          <LobbyWiseOutsideRest data={filteredData} />
        )}
        {filteredData?.length > 0 && (
          <MonthWiseOutsideRest data={filteredData} />
        )} */}
        {filteredData?.length > 0 && (
          <CrewOutsideGraph
            data={filteredData}
            selectedBar={selectedBar}
            setTreeMapPath={setTreeMapPath}
            setSelectedLineBar={setSelectedLineBar}
          />
        )}
        {filteredData?.length > 0 && (
          <StationWiseOutSideRest
            data={filteredData}
            selectedBar={selectedBar}
            treeMapPath={treeMapPath}
          />
        )}
      </>
    </div>
  );
};

export default CrewOutsideMaster;
